import styled from 'styled-components';
import { typography } from '@/designSystem/typography';
import { colors } from '@/designSystem/colors';

export const Content = styled.div`
  height: 250px;
`;

export const Description = styled.p`
  ${typography.xs};
  color: ${colors.grey};
`;

export const Margin = styled.div`
  margin-top: 20px;
`;

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 16px 0px;
  gap: 20px;
`;
export const ModalDescription = styled.p`
  ${typography.md}
  color: ${colors.text};
  margin: 16px 0px 20px 0px;
`;

export const LoadingContainer = styled.div`
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
`;

export const LoadingDescription = styled.p`
  ${typography.xs}
  color: ${colors.text};
  margin: 8px;
  text-align: center;
`;
